export default function ProductsHeroFr() {
  return (
    <section className="relative w-full h-[280px] md:h-[340px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://public.readdy.ai/ai/img_res/cd5276e5be81e40f7caee6a5980dbf7e.jpg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-stone-900/80 via-stone-900/60 to-stone-900/30" />
      <div className="relative z-10 w-full px-6 md:px-16">
        <span className="text-emerald-400 text-xs font-bold uppercase tracking-widest block mb-3">
          INGRÉDIENTS &amp; Produits chimiques fins
        </span>
        <h1
          className="text-4xl md:text-5xl font-extrabold text-white leading-tight mb-4"
          style={{ fontFamily: "'DM Serif Display', serif" }}
        >
          Nos Produits
        </h1>
        <p className="text-white/70 text-base max-w-xl leading-relaxed">
          Ingrédients, excipients et produits chimiques fins approvisionnés auprès de fournisseurs mondiaux de qualité.
        </p>
      </div>
    </section>
  );
}
